import { Heading, Text } from "../../Type";
import Button from "../../Button";
import TextLink from "../../TextLinks";

import styles from "./index.module.scss";
import { UserType } from "../../../types/userType";

type PropsType = {
  newUser: UserType;
  switchModals: () => void;
  setConfirmationModalOpen: (open: boolean) => void;
};

const NewUserConfirmation = ({
  newUser,
  switchModals,
  setConfirmationModalOpen,
}: PropsType) => {
  return (
    <div className={styles.confirmationModal}>
      <Heading size="h3">
        Email sent to {newUser.first_name} {newUser.last_name}
      </Heading>
      <Text className={styles.modalText}>
        A signup link has been emailed to{" "}
        <span className={styles.bold}>
          {newUser.first_name} {newUser.last_name}
        </span>{" "}
        ({newUser.email}).
      </Text>
      <div className={styles.horizontalLine100} />
      <div className={styles.modalButtonsContainer}>
        <TextLink onClick={() => switchModals()}>Create another user</TextLink>
        <Button primary onClick={() => setConfirmationModalOpen(false)}>
          Close
        </Button>
      </div>
    </div>
  );
};
export default NewUserConfirmation;
